import sample_1 from './100_71439.jpg';

export const moveImpressions = {
    sample_1,
};
